interface ObservedElement extends HTMLElement {
  observer: IntersectionObserver
}

export default defineNuxtPlugin( ( nuxtApp ) => {
  nuxtApp.vueApp.directive( "slideIn", {
    created ( el: ObservedElement ) {
      el.observer = new IntersectionObserver( entries => {
        // Loop over the entries
        entries.forEach( entry => {
          // If the element is visible
          if ( entry.isIntersecting ) {
            // Add the animation class
            const target = entry.target as HTMLElement
            target.style.setProperty( "opacity", "1" )
            target.style.setProperty( "transform", "translate(0%, 0%)", "important" )
          }
        } )
      } )
    },
    mounted ( el: ObservedElement, binding: { value?: { duration?: number, delay?: number } } ) {
      const duration = binding.value?.duration ?? 0.6
      const delay = binding.value?.delay ?? 0.5
      el.style.opacity = "0"
      el.style.transform = "translate(0%, 30%)"
      el.style.transitionProperty = "opacity, transform"
      el.style.transitionTimingFunction = "ease"
      el.style.transitionDuration = `${duration * 1000}ms`
      el.style.transitionDelay = `${delay * 1000}ms`
      el.observer.observe( el )
    },
    beforeUnmount( el: ObservedElement ) {
      if ( el.observer ) {
        el.observer.unobserve( el )
      }
    }
  } )
} )
